/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { divideDependencies } from './dependenciesDivide.generated.js';
import { equalDependencies } from './dependenciesEqual.generated.js';
import { factorialDependencies } from './dependenciesFactorial.generated.js';
import { gammaDependencies } from './dependenciesGamma.generated.js';
import { isNegativeDependencies } from './dependenciesIsNegative.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { piDependencies } from './dependenciesPi.generated.js';
import { powDependencies } from './dependenciesPow.generated.js';
import { sinDependencies } from './dependenciesSin.generated.js';
import { smallerEqDependencies } from './dependenciesSmallerEq.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createZeta } from '../../factoriesAny.js';
export var zetaDependencies = {
  BigNumberDependencies,
  ComplexDependencies,
  addDependencies,
  divideDependencies,
  equalDependencies,
  factorialDependencies,
  gammaDependencies,
  isNegativeDependencies,
  multiplyDependencies,
  piDependencies,
  powDependencies,
  sinDependencies,
  smallerEqDependencies,
  subtractDependencies,
  typedDependencies,
  createZeta
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesZeta.generated.js
// module id = RejN
// module chunks = 3